import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { pdfStylesV2, divisorV2, PDF_COLORS, PDF_PAGE_MARGINS, pdfFz, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFCompanyInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCompanyInfo";
import { PDFItemsTableV2, PDFItemImagesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFKioskoQRV2, PDFTextoAdicionalV2, PDFBrandFooterConNumeroV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { PDFEquipoMedicoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFEquipoMedico";
import { PDFPagareV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPagare";
import { formatearDireccionEntrega } from "../../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../../Components/PdfComponents/BloqueFirmasPdf";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const remisionPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const dataSat = values.respuestaFactura.dataSat;
  const idKiosko = values.kioskoid;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const decimalesTipoCambioPdf = Number.isFinite(Number(empresa?.decimalesTipoCambioPdf)) ? Number(empresa.decimalesTipoCambioPdf) : 4;
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  const direccionEntrega = values.respuestaFactura?.dataSat?.direccionEntrega || [];
  // Texto, no arreglo: kvRows esparce cualquier objeto como nodo y con [] la celda queda sin
  // `text` (pdfmake: "Unrecognized document structure"). Las respuestas de agregarVenta,
  // generarFactura, etc. no traen `proyecto`; solo obtenerRespuestaFactura lo arma.
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || "";

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || values.quitarImpuestos || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  // Importe de cada renglón con sus impuestos; "No Desglosar Imp. Remisiones" ya los incluye
  const importeConImpuestos = empresa?.importeConImpuestos === true && !quitarImpuestosRemisiones;
  const tituloImporte = importeConImpuestos ? "Importe con Impuestos" : "Importe";
  let agregarImpDesc = 0;

  // Ocultar clave y clave SAT
  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot;
  const mostrarClave = !empresa?.deshabilitarClaveCot;

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;
  const widthIVA = 8;
  const widthPU = quitarImpuestosRemisiones ? 15 : 10.5;
  const widthImporte = quitarImpuestosRemisiones ? 15 : 12.5;

  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const mostrarTipoComprobante = !empresa?.deshabilitarTipoComprobantePdf;
  const mostrarMoneda = !empresa?.deshabilitarMonedaPdf;
  const mostrarLugarExpedicion = !empresa?.deshabilitarLugarExpedicionPdf;
  const mostrarCondicionesPago = !empresa?.deshabilitarCondicionesPagoPdf;
  const mostrarCPCliente = !empresa?.deshabilitarCPClientePdf;
  const mostrarFormaPago = !empresa?.deshabilitarFormaPagoPdf;
  const mostrarMetodoPago = !empresa?.deshabilitarMetodoPagoPdf;
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFecha = !empresa?.deshabilitarFechaPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;
  const ocultarColumnaPU = false;
  const ocultarColumnaImporte = false;
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true && !ocultarColumnaPU;
  const widthPUConDescuento = 9;
  const mostrarCuadroTotales = true;
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );

  let widthExtraDescripcion = 0;
  if (!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if (!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !empresa.imprimirIEPS) {
    widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA) {
    widthExtraDescripcion += widthIVA;
  }
  if (ocultarColumnaPU) widthExtraDescripcion += widthPU;
  if (ocultarColumnaImporte) widthExtraDescripcion += widthImporte;

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;

  // --- Equipo médico (misma condición que el clásico) ---
  const agregarEquipoMedico = PDFEquipoMedicoV2({ values, empresa });

  // Helper: valida que sea una data URL base64 aceptada por pdfMake
  const esDataUrlValida = (s) =>
    typeof s === "string" &&
    /^data:(image|application)\/[a-zA-Z0-9.+-]+;base64,/.test(s);

  const conceptos = dataSat.Conceptos.flatMap((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    const relacionDescuento = Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Importe || 1);

    valueConcepto.Impuestos?.Traslados?.forEach((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);
    const precioUnitarioNetoConImpuestos = (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1);

    const imagenesEntrada = Array.isArray(valueConcepto.imagenes) ? valueConcepto.imagenes : [];
    const imagenesBase64 = imagenesEntrada
      .map((img) => (typeof img === "string" ? img : img?.base64Completa))
      .filter(esDataUrlValida);

    const tabla = dataSat.Receptor.impresionEspecial
      ? [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "center" }]),
        {
          text: (() => {
            const textoUnidad = (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad;
            return valueConcepto.presentacionCliente || textoUnidad;
          })(),
          style: "textoTablaChico",
          alignment: "center",
        },
        { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
        (() => {
          const textoDescSinObs =
            valueConcepto.Descripcion +
            (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
            (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
            (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
          const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
          const extras = [];
          if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
            extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
          }
          if (Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0) {
            extras.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
          }
          const imgsNode = PDFItemImagesV2(imagenesBase64);
          if (imgsNode) extras.push(imgsNode);
          if (valueConcepto.DescripcionLarga) {
            // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
            return {
              stack: [
                { text: textoDescSinObs, style: "textoTablaChico" },
                { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
                ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                ...extras,
              ],
              alignment: "left",
            };
          }
          if (extras.length) {
            return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left" };
          }
          return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
        })(),
        ...(cantidadJuntoPrecioUnitario ? [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "center" }] : []),
        {
          stack: [
            { text: dineroDisabledMask(valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "left" },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    {
                      text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%",
                      width: "*", alignment: "left", style: "descuentoPartida", noWrap: true,
                    },
                    {
                      text: dineroDisabledMask(round2Decimals(Number(valueConcepto.Descuento) / Number(valueConcepto.Cantidad || 1))),
                      width: "auto", style: "descuentoPartida",
                    }
                  ],
                  columnGap: 8, margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        },
        ...(precioUnitarioConDescuento ? [{ text: dineroDisabledMask(precioUnitarioNeto, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "left" }] : []),
        ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "left" }]),
        { text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "left" },
        {
          stack: [
            { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "left" },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "right", margin: [0, 2, 0, 0] }]
                : []
            )
          ]
        }
      ]
      : [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" }]),
        {
          text: (() => {
            const textoUnidad = (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad;
            return valueConcepto.presentacionCliente || textoUnidad;
          })(),
          style: "textoTablaChico", alignment: "center",
        },
        ...(mostrarClaveSAT ? [{ text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" }] : []),
        ...(mostrarClave ? [{ text: valueConcepto.NoIdentificacion, style: "textoTablaChico", alignment: "center" }] : []),
        (() => {
          const textoDescSinObs =
            valueConcepto.Descripcion +
            (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
            (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
            (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
          const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
          const extras = [];
          if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
            extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
          }
          if (Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0) {
            extras.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
          }
          const imgsNode = PDFItemImagesV2(imagenesBase64);
          if (imgsNode) extras.push(imgsNode);
          if (valueConcepto.DescripcionLarga) {
            // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
            return {
              stack: [
                { text: textoDescSinObs, style: "textoTablaChico" },
                { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
                ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                ...extras,
              ],
              alignment: "left",
            };
          }
          if (extras.length) {
            return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left" };
          }
          return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
        })(),
        ...(cantidadJuntoPrecioUnitario ? [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" }] : []),
        ...(ocultarColumnaPU ? [] : [{
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosRemisiones
                  ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                  : valueConcepto.ValorUnitario,
                decimalesPrecioUnitarioPdf
              ),
              style: "textoTablaChico", alignment: "right", noWrap: true,
            },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    {
                      text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%",
                      width: "*", alignment: "left", style: "descuentoPartida", noWrap: true,
                    },
                    {
                      text: dineroDisabledMask(round2Decimals(Number(valueConcepto.Descuento) / Number(valueConcepto.Cantidad || 1))),
                      width: "auto", style: "descuentoPartida",
                    }
                  ],
                  columnGap: 8, margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        }]),
        ...(precioUnitarioConDescuento ? [{
          text: dineroDisabledMask(quitarImpuestosRemisiones ? precioUnitarioNetoConImpuestos : precioUnitarioNeto, decimalesPrecioUnitarioPdf),
          style: "textoTablaChico", alignment: "right", noWrap: true,
        }] : []),
        ...(quitarImpuestosRemisiones ? [] : [
          ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "right", noWrap: true }]),
          ...(empresa.imprimirIEPS ? [{ text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "right", noWrap: true }] : []),
        ]),
        ...(ocultarColumnaImporte ? [] : [{
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosRemisiones
                  ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                  : importeConImpuestos
                    ? Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps
                    : valueConcepto.Importe
              ),
              style: "textoTablaChico", alignment: "right", noWrap: true,
            },
            ...(
              !importeConImpuestos && !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "right", margin: [0, 2, 0, 0] }]
                : []
            )
          ]
        }])
      ];

    return [tabla];
  });

  const title = dataSat.Receptor.impresionEspecial
    ? [
      { text: "Line Item\nNumber:", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cantidad\n(Order Qty):", style: "tituloTabla" }]),
      { text: "Unidad\n(Unit):", style: "tituloTabla" },
      { text: "Clave\nSAT:", style: "tituloTabla" },
      { text: "Descripción:", style: "tituloTabla", alignment: "left" },
      ...(cantidadJuntoPrecioUnitario ? [{ text: "Cantidad\n(Order Qty):", style: "tituloTabla" }] : []),
      { text: "P/U\n(Price Per Unit):", style: "tituloTabla", alignment: "left" },
      ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.\n(Net Price):", style: "tituloTabla", alignment: "left" }] : []),
      ...(ocultarColumnaIVA ? [] : [{ text: "IVA:", style: "tituloTabla", alignment: "left" }]),
      { text: "IEPS:", style: "tituloTabla", alignment: "left" },
      { text: "Importe\n(Net Value):", style: "tituloTabla", alignment: "left" },
    ]
    : [
      { text: "", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
      { text: "Unidad", style: "tituloTabla" },
      ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
      ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
      { text: "Descripción", style: "tituloTabla" },
      ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
      ...(ocultarColumnaPU ? [] : [{ text: "P/U", style: "tituloTabla" }]),
      ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
      ...(quitarImpuestosRemisiones ? [] : [
        ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
        ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
      ]),
      ...(ocultarColumnaImporte ? [] : [{ text: tituloImporte, style: "tituloTabla" }]),
    ];

  // Anchos de Cant/Unidad/Descripción ajustados (ver comentarios) independientemente de la posición de Cant
  const widths = dataSat.Receptor.impresionEspecial
  ? [
    "8%",
    ...(cantidadJuntoPrecioUnitario ? [] : ["10%"]),  // Cant
    "10%",  // Unidad
    "8%",
    `${23 + (ocultarColumnaIVA ? 7 : 0) - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,  // Descripción (-3% para compensar)
    ...(cantidadJuntoPrecioUnitario ? ["10%"] : []),  // Cant
    "13%", ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), ...(ocultarColumnaIVA ? [] : ["7%"]), "7%", "14%",
  ]
  : quitarImpuestosRemisiones
    ? [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${9 + widthExtraCantidad}%`]),  // ← Cant 7→9
      `${10 + widthExtraUnidad}%`,  // ← Unidad 8→10
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${32 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,  // ← Descripción 36→32 (-4% para compensar)
      ...(cantidadJuntoPrecioUnitario ? [`${9 + widthExtraCantidad}%`] : []),  // ← Cant 7→9
      ...(ocultarColumnaPU ? [] : ["15%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaImporte ? [] : ["15%"]),
    ]
    : [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${7 + widthExtraCantidad}%`]),  // ← Cant 4→7
      `${10 + widthExtraUnidad}%`,  // ← Unidad 7→10
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${21 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,  // ← Descripción 27→21 (-6% para compensar)
      ...(cantidadJuntoPrecioUnitario ? [`${7 + widthExtraCantidad}%`] : []),  // ← Cant 4→7
      ...(ocultarColumnaPU ? [] : ["10.5%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaIVA ? [] : ["8%"]),
      ...(empresa.imprimirIEPS ? [`${widthIEPS}%`] : []),
      ...(ocultarColumnaImporte ? [] : ["12.5%"]),
    ];

  // --- Bloque de impresión especial (inglés) ---
  const impresionEspecial = dataSat.Receptor.impresionEspecial
    ? [
      PDFCompanyInfoV2({
        left: [
          { label: "Purchase Order #:", value: dataSat?.pedido ? dataSat.pedido : "N/A" },
          { label: "Invoice number:", value: (dataSat.Serie ? dataSat.Serie : "F") + " - " + dataSat.Folio },
          { label: "Invoice date:", value: moment(dataSat.Fecha).locale("es").format("DD/MM/YYYY") },
        ],
        right: [
          {
            label: "Terms:",
            value: dataSat?.Receptor?.diasCredito && dataSat?.Receptor?.diasCredito > 0
              ? dataSat?.Receptor?.diasCredito + " days"
              : "Immediate Payment",
          },
          {
            label: "Seller:",
            value: empresa.persona
              ? empresa.nombre
              : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno,
          },
        ],
        labelWidthLeft: "40%",
        labelWidthRight: "40%",
      }),
    ]
    : [];

  // --- Impuestos (mismo cálculo que el clásico; salida {label,value}) ---
  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [
      ...dataSat.Impuestos.Traslados,
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || []),
    ];

  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002" ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%` : a.Impuesto === "003" ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%` : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002" ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%` : b.Impuesto === "003" ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%` : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  let totalImpuestos = 0;

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") nombre = "IVA";
    else if (valueImpuesto.Impuesto === "003") nombre = "IEPS";
    else nombre = valueImpuesto["@ImpLocTrasladado"];

    if (valueImpuesto.TipoFactor === "Tasa") nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    else if (valueImpuesto.TipoFactor === "Cuota") nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);

    totalImpuestos += valueImpuesto.Importe || valueImpuesto["@Importe"];
    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [
      ...dataSat.Impuestos.Retenciones,
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || []),
    ];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") nombre = nombre + "ISR";
    else if (valueRetencion.Impuesto === "002") nombre = nombre + "IVA";
    else nombre = valueRetencion["@ImpLocRetenido"];
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const mostrarBancos = !dataSat?.deshabilitarBanco;

  const filasBanco1 = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const filasBanco2 = empresa.banco2 && empresa.banco2 !== ""
    ? [
      { label: "Banco:", value: empresa.banco2 ? empresa.banco2 : "" },
      ...(empresa.swiftCode2 ? [{ label: "Swift Code:", value: empresa.swiftCode2 ? empresa.swiftCode2 : "" }] : []),
      ...(empresa.abaCode2 ? [{ label: "ABA Code:", value: empresa.abaCode2 ? empresa.abaCode2 : "" }] : []),
      { label: "Cuenta:", value: empresa.cuentaBanco2 ? empresa.cuentaBanco2 : "" },
      { label: "Cuenta CLABE:", value: empresa.cuentaClabe2 ? empresa.cuentaClabe2 : "" },
    ]
    : [];

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["@TotaldeRetenciones"] || 0) || 0;

  const vendedorVar = empresa.vendedorVentas && values.vendedor ? values.vendedor : null;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: "CANCELADO", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  } else if (values.esPreview) {
    cancelado = { watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 } };
  }

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  // --- Metadata del encabezado (derecha) ---
  const headerMeta = [
    { label: "N° Remisión:", value: (dataSat.Serie ? dataSat.Serie : "R") + " - " + dataSat.Folio + (values.sufijoPartida ? " " + values.sufijoPartida : "") },
    ...(mostrarMoneda ? [{ label: "Moneda:", value: dataSat.Moneda }] : []),
    { label: "T.C.:", value: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf) },
    ...(mostrarLugarExpedicion ? [{ label: "Lugar de expedición:", value: dataSat.LugarExpedicion }] : []),
    ...(mostrarOC ? [{ label: "O.C.:", value: dataSat.pedido ? dataSat.pedido : "" }] : []),
    ...(dataSat.req ? [{ label: "Req:", value: dataSat.req }] : []),
    ...(mostrarCondicionesPago ? [{
      label: "Condiciones de pago:",
      value: dataSat.condicion === 1
        ? "Contado"
        : "Crédito (" + (dataSat?.Receptor?.diasCredito ? dataSat?.Receptor?.diasCredito : "0") + " días)",
    }] : []),
    ...(vendedorVar
      ? [{
        label: "Vendedor:",
        value: vendedorVar.nombre + (vendedorVar.apellidoPaterno ? " " + vendedorVar.apellidoPaterno : "") + (vendedorVar.apellidoMaterno ? " " + vendedorVar.apellidoMaterno : ""),
      }]
      : []),
  ];

  // --- Datos cliente / proyecto ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    ...(dataSat?.Receptor?.codigoProveedor ? [{ label: "Código Proveedor:", value: dataSat.Receptor.codigoProveedor }] : []),
    ...(mostrarFecha ? [{ label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") }] : []),
    ...(mostrarCPCliente ? [{ label: "CP:", value: dataSat?.Receptor?.DomicilioFiscalReceptor ? dataSat.Receptor.DomicilioFiscalReceptor : "" }] : []),
    ...(mostrarFormaPago ? [{ label: "Forma de pago:", value: "(" + dataSat.formaDePago.c_FormaPago + ") " + dataSat.formaDePago.descripcion }] : []),
    ...(mostrarMetodoPago ? [{ label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" }] : []),
  ];

  const clienteRight = [
    ...(empresa?.mostrarProyectoVentas ? [{ label: "Proyecto:", value: proyecto, strong: true }] : []),
    ...(referenciaEntrega ? [{ label: "Referencia:", value: referenciaEntrega }] : []),
    ...(direccionEntrega?.destino ? [{ label: "Destino:", value: direccionEntrega?.destino }] : []),
    ...(direccionEntrega?.embarque ? [{ label: "Embarque:", value: direccionEntrega?.embarque }] : []),
    ...(direccionEntregaTexto ? [{ label: "Dirección de Entrega:", value: direccionEntregaTexto }] : []),
    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada ? [{ label: "Fecha de entrega estimada:", value: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL") }] : []),
    ...(values.sinContabilidad && values.fechaPagoInformativa ? [{ label: "Fecha de pago:", value: moment(values.fechaPagoInformativa).locale("es").format("LL") }] : []),
    ...(dataSat?.atencion ? [{ label: "Atención a:", value: dataSat.atencion }] : []),
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  // Solo se muestran filas bancarias con valor visible; si ninguna lo tiene,
  // se oculta toda la sección "Datos bancarios" (incluido su título).
  const bancosRows = (mostrarBancos ? [...filasBanco1, ...filasBanco2] : [])
    .filter((r) => r && String(r.value ?? "").trim() !== "");
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };
  const cierreIzquierda = {
    stack: [
      ...(mostrarCuadroTotales ? [importeLetra] : []),
      ...(bancosRows.length ? [PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: bancosRows })] : []),
      PDFKioskoQRV2(idKiosko),
    ],
  };

  // --- Filas de totales (derecha) ---
  const totalsRows = [
    {
      label: "Subtotal:",
      value: dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.SubTotal + totalImpuestos + agregarImpDesc : dataSat.SubTotal),
    },
    ...(((quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento) > 0)
      ? [{
        label: "Descuento:",
        value: "- " + dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento),
      }]
      : []),
    ...(quitarImpuestosRemisiones ? [] : impuestosTotales),
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  // --- Pagaré ---
  let anadirPagare = [];
  if (values.imprimirPagare && values.textoPagare) {
    anadirPagare = PDFPagareV2({
      empresa,
      meta: [
        { label: "N° Remisión:", value: (dataSat.Serie ? dataSat.Serie : "R") + " - " + dataSat.Folio + (values.sufijoPartida ? " " + values.sufijoPartida : "") },
        { label: "Moneda:", value: dataSat.Moneda },
        { label: "Tipo de Cambio:", value: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf) },
      ],
      buenoPor: dineroDisabledMask(dataSat.Total),
      texto: values.textoPagare,
      pagareCorto: values.pagareCorto,
    });
  }

  const dd = {
    ...cancelado,
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Remisión",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "R") + " - " + dataSat.Folio + (values.sufijoPartida ? " " + values.sufijoPartida : ""),
        regimenFiscal: mostrarRegimen,
        tipoComprobante: mostrarTipoComprobante ? "ingreso" : false,
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 6, 1),
      ...(impresionEspecial.length ? [...impresionEspecial, divisorV2(PDF_COLORS.neutralDivider, 7, 1)] : []),
      ...agregarEquipoMedico,
      PDFItemsTableV2({ title, conceptos, widths }),
      PDFSummarySectionV2({ left: cierreIzquierda, rows: mostrarCuadroTotales ? totalsRows : [] }),
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      ...anadirPagare,
      PDFTextoAdicionalV2(empresa.textoAdicional || null),
      ...(empresa?.camposFirmaVentas ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])] : []),
    ],
    footer: PDFBrandFooterConNumeroV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  return dd;
};

export default remisionPdfV2;
